<template>
  <div class="home">
    <ThreeD/>
    <Product/>
    <a href="#" class="go-top" id="backTop">
      <v-icon name="arrow-up"/> 
    </a>
    <!-- <section class="page3">
      
    </section> -->
    <Company/>
    <Exhibition/>
    <Project/>
    <Page2/>
    <Achievements/>
    <!-- <Team/> -->
    
     
  </div>
</template>

<script>
import ThreeD from './3D'
import Product from './Product'
import Company from './Company'
import Exhibition from './Exhibition'
// import Page from './Page'
import Page2 from './Page2'
// import Team from './Team'
// import Partners from './Partners'
import Project from './Project'
import Achievements from './Achievement'

export default {
  name: 'home',
  components: {
    ThreeD,
    Product,
    Company,
    Exhibition,
    // Page,
    Page2,
    // Team,
    // Partners,
    Project,
    Achievements,
  },
  // methods: {
  //   onScroll() {
  //     let topH = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
  //     backTopSpeed = Math.floor(-topH/8);
  //     if (topH >0) {
  //       document.documentElement.scrollTop = document.body.scrollTop = topH+backTopSpeed;
  //     }else{
  //       clearInterval(backTopTimer);
  //     }
  //   }
  // },
  // mounted(){
  //   window.onclick('scroll', this.onScroll)
  // },
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;

  .go-top {
    position: fixed;
    display: block;
    cursor: pointer;
    bottom: 30px;
    right: 0;
    color: #ffffff;
    background-color: #e36cd9;
    z-index: 99;
    width: 45px;
    text-align: center;
    height: 45px;
    border-radius: 10px 0 0 10px;
    line-height: 46px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    &:hover {
      background-color: #44ce6f;
    }
  }
}
</style>
